export default {
  'role.query.roleName': '角色名称',
  'role.query.roleName.placeholder': '输入要查找的角色名称',
  'role.column.roleName': '角色名称',
  'role.column.description': '角色描述',
  'role.column.roleKey': '权限字符串',
  'role.column.status': '状态',
  'role.column.status.normal': '正常',
  'role.column.status.disable': '禁用',
  'role.button.roleMember': '分配用户',
  'role.button.dataScope': '数据权限',
  'role.importDialog.tip': '状态字段可选项：正常、禁用',
  // edit
  'role.edit.title': '编辑角色',
  'role.edit.success': '修改成功',
  'role.add.title': '新增角色',
  'role.add.success': '新增成功',
  'role.edit.button.prev': '上一步',
  'role.edit.button.next': '下一步',
  'role.edit.step.roleInfo': '角色信息',
  'role.edit.step.funcPermission': '功能权限',
  'role.edit.form.roleName': '角色名称',
  'role.edit.form.roleName.placeholder': '请输入角色名称',
  'role.edit.form.roleName.required': '请输入角色名称',
  'role.edit.form.description': '角色描述',
  'role.edit.form.description.placeholder': '请输入角色描述',
  'role.edit.form.roleKey': '权限字符串',
  'role.edit.form.roleKey.placeholder': '请输入权限字符串',
  'role.edit.form.roleKey.required': '请输入权限字符串',
  'role.edit.form.status': '角色状态',
  'role.edit.form.status.required': '请选择角色状态',
  'role.edit.form.status.normal': '正常',
  'role.edit.form.status.disable': '停用',
  'role.edit.form.menuPermission': '菜单权限',
  'role.edit.form.menuPermission.expand': '展开/折叠',
  'role.edit.form.menuPermission.checkedAll': '全选/全不选',
  'role.edit.form.menuPermission.checkStrictly': '父子联动',
  'role.edit.form.menuPermission.filterKeyword': '输入关键字进行搜索',
  'role.edit.form.menuPermission.emptyText': '暂无数据',
  // role user drawer
  'role.userDrawer.title': '分配用户',
  'role.userDrawer.cancelAuthConfirm': '确认要取消授权选中的{length}条记录吗？',
  'role.userDrawer.cancelAuthConfirm.single': '确认要取消授权用户【{username}】吗？',
  'role.userDrawer.cancelAuthSuccess': '取消授权成功',
  'role.userDrawer.query.nickname': '用户名称',
  'role.userDrawer.query.nickname.placeholder': '输入要查找的用户名称',
  'role.userDrawer.query.mobile': '手机号',
  'role.userDrawer.query.mobile.placeholder': '输入要查找的手机号',
  'role.userDrawer.button.addAuthUser': '添加授权用户',
  'role.userDrawer.button.batch.cancelAuth': '批量取消授权',
  'role.userDrawer.column.username': '登录名',
  'role.userDrawer.column.nickname': '用户昵称',
  'role.userDrawer.column.deptId': '部门',
  'role.userDrawer.column.mobile': '手机号码',
  'role.userDrawer.column.status': '状态',
  'role.userDrawer.column.status.normal': '正常',
  'role.userDrawer.column.status.disable': '禁用',
  'role.userDrawer.column.lastActiveTime': '最后活跃时间',
  'role.userDrawer.button.cancelAuth.title': '取消授权',
  // add auth user dialog
  'role.addAuthUserDialog.title': '添加授权用户',
  'role.addAuthUserDialog.confirm': '确定要给这 {length} 个用户分配角色吗？',
  'role.addAuthUserDialog.success': '授权成功',
  'role.addAuthUserDialog.query.nickname': '用户名称',
  'role.addAuthUserDialog.query.nickname.placeholder': '输入要查找的用户名称',
  'role.addAuthUserDialog.query.mobile': '手机号',
  'role.addAuthUserDialog.query.mobile.placeholder': '输入要查找的手机号',
  'role.addAuthUserDialog.button.batchAuth': '批量授权',
  'role.addAuthUserDialog.column.username': '登录名',
  'role.addAuthUserDialog.column.nickname': '用户昵称',
  'role.addAuthUserDialog.column.deptId': '部门',
  'role.addAuthUserDialog.column.mobile': '手机号码',
  'role.addAuthUserDialog.column.status': '状态',
  'role.addAuthUserDialog.column.status.normal': '正常',
  'role.addAuthUserDialog.column.status.disable': '禁用',
  'role.addAuthUserDialog.column.lastActiveTime': '最后活跃时间',
  // data scope dialog
  'role.dataScopeDialog.title': '分配数据权限',
  'role.dataScopeDialog.success': '分配成功',
  'role.dataScopeDialog.form.dataScope': '权限范围',
  'role.dataScopeDialog.form.dataScope.required': '请选择权限范围',
  'role.dataScopeDialog.form.dataPermission': '数据权限',
  'role.dataScopeDialog.form.dataPermission.expand': '展开/折叠',
  'role.dataScopeDialog.form.dataPermission.checkedAll': '全选/全不选',
  'role.dataScopeDialog.form.dataPermission.checkStrictly': '父子联动',
  'role.dataScopeDialog.form.dataPermission.filterKeyword': '输入关键字进行搜索',
  'role.dataScopeDialog.form.dataPermission.emptyText': '暂无数据',
}
